import React from "react";
import sideimg from "../../../src/assets/Images/nonAuth/careerpageimage.png";

const WhyJoinUs = () => {
  return (
    <div className="bg-white py-12">
      <div className="container mx-auto px-4 md:px-8 w-full">
        <div className="flex flex-col md:flex-row items-center gap-8">
          {/* Left content */}
          <div className="w-full md:w-1/2 space-y-8">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800">
              Why Join Us
            </h2>

            <div className="space-y-6">
              <div>
                <h3 className="text-xl font-bold text-gray-800">
                  Be Part Of A Growing Industry
                </h3>
                <p className="text-gray-600 mt-1">
                  The construction and building materials sector is booming –
                  and so are we.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-bold text-gray-800">
                  Start-Up Energy, Real Impact
                </h3>
                <p className="text-gray-600 mt-1">
                  Work closely with founders, contribute to big decisions, and
                  see your ideas come to life.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-bold text-gray-800">
                  Diverse Roles, Common Mission
                </h3>
                <p className="text-gray-600 mt-1">
                  From warehouse operations to marketing to software development
                  – we're all working toward one goal: making building materials
                  accessible, affordable, and reliable.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-bold text-gray-800">
                  On-The-Ground & Online
                </h3>
                <p className="text-gray-600 mt-1">
                  We combine smart logistics, tech-driven platforms, and a deep
                  understanding of the industry. Join us where tech meets
                  real-world impact.
                </p>
              </div>
            </div>
          </div>

          {/* Right image */}
          <div className="w-full md:w-1/2 mt-8 md:mt-0">
            <div className="rounded-lg overflow-hidden bg-pink-100 p-4">
              <img
                src={sideimg}
                alt="Join our team"
                className="w-full h-auto object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyJoinUs;
